import { PlaybookLeverType } from 'src/services';
import { VariantFeature } from 'src/components-bl/Experiment/ExperimentForm/VariantPanel/constants';

/**
 * The Playbook Bank speaks in `PlaybookLeverType` (ranking_strategy/merchandising_rule/view_config),
 * but the mega-drawer's editing components are keyed by `VariantFeature`. This maps step 2's choice
 * (from either a playbook or "build your own") onto the `VariantFeature` step 3 renders.
 */
export const LEVER_TYPE_TO_VARIANT_FEATURE: Partial<Record<PlaybookLeverType, VariantFeature>> = {
  ranking_strategy: VariantFeature.RankingStrategy,
  merchandising_rule: VariantFeature.MerchandisingRules,
  view_config: VariantFeature.RecEnginesGeneralSettings,
};

export const mapLeverTypeToVariantFeature = (
  leverType: PlaybookLeverType
): VariantFeature | undefined => LEVER_TYPE_TO_VARIANT_FEATURE[leverType];
